module.exports = __webpack_public_path__ + "static/img/a060.3ddad1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a060.jpg
// module id = 4MoY
// module chunks = 0